const apiUrl = process.env.REACT_APP_API_URL;
export const PostAulaIdProjecte = async (id_aula: string, json: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/projecte`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(json)
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
